import React, { useState } from 'react';
import '../../styles/Dashboard.css';
import ServiceSelection from './ServiceSelection';
import ProjectTracker from './ProjectTracker';
import Payment from './Payment';
import Scheduler from './Scheduler';
import UserProfile from './UserProfile';
import Notifications from './Notifications';
import RequestHistory from './RequestHistory';
import SupportChat from './SupportChat';

function Dashboard() {
  const [activeSection, setActiveSection] = useState('services');

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.reload(); // Simple logout - adjust as needed
  };

  return (
    <div className="sp-dashboard">
      <nav className="sp-drawer">
        <button className="sp-nav-btn" onClick={() => setActiveSection('services')}>Services</button>
        <button className="sp-nav-btn" onClick={() => setActiveSection('tracker')}>Track Projects</button>
        <button className="sp-nav-btn" onClick={() => setActiveSection('payment')}>Payments</button>
        <button className="sp-nav-btn" onClick={() => setActiveSection('scheduler')}>Schedule</button>
        <button className="sp-nav-btn" onClick={() => setActiveSection('profile')}>Profile</button>
        <button className="sp-nav-btn" onClick={() => setActiveSection('notifications')}>Notifications</button>
        <button className="sp-nav-btn" onClick={() => setActiveSection('history')}>Request History</button>
        <button className="sp-nav-btn" onClick={() => setActiveSection('support')}>Support Chat</button>
        <button className="sp-logout-btn" onClick={handleLogout}>Logout</button>
      </nav>
      <div className="sp-dashboard-content">
        {activeSection === 'services' && <ServiceSelection />}
        {activeSection === 'tracker' && <ProjectTracker />}
        {activeSection === 'payment' && <Payment />}
        {activeSection === 'scheduler' && <Scheduler />}
        {activeSection === 'profile' && <UserProfile />}
        {activeSection === 'notifications' && <Notifications />}
        {activeSection === 'history' && <RequestHistory />}
        {activeSection === 'support' && <SupportChat />}
      </div>
    </div>
  );
}

export default Dashboard;